'use strict';

angular.module('adelementAdminApp').controller('UserAdvertiserMappingDialogController',
    ['$scope', '$stateParams', '$uibModalInstance', 'entity', 'UserAdvertiserMapping',
        function($scope, $stateParams, $uibModalInstance, entity, UserAdvertiserMapping) {

        $scope.userAdvertiserMapping = entity;
        $scope.load = function(id) {
            UserAdvertiserMapping.get({id : id}, function(result) {
                $scope.userAdvertiserMapping = result;
            });
        };

        var onSaveSuccess = function (result) {
            $scope.$emit('adelementAdminApp:userAdvertiserMappingUpdate', result);
            $uibModalInstance.close(result);
            $scope.isSaving = false;
        };

        var onSaveError = function (result) {
            $scope.isSaving = false;
        };

        $scope.save = function () {
            $scope.isSaving = true;
            if ($scope.userAdvertiserMapping.id != null) {
                UserAdvertiserMapping.update($scope.userAdvertiserMapping, onSaveSuccess, onSaveError);
            } else {
                UserAdvertiserMapping.save($scope.userAdvertiserMapping, onSaveSuccess, onSaveError);
            }
        };

        $scope.clear = function() {
            $uibModalInstance.dismiss('cancel');
        };
}]);
